function captureConsole(method, callback) {
  const messages = [];
  const original = console[method];
  console[method] = (...args) => {
    messages.push(args.map(String).join(" "));
  };
  try {
    callback();
  } finally {
    console[method] = original;
  }
  return messages;
}
async function captureConsoleAsync(method, callback) {
  const messages = [];
  const original = console[method];
  console[method] = (...args) => {
    messages.push(args.map(String).join(" "));
  };
  try {
    await callback();
  } finally {
    console[method] = original;
  }
  return messages;
}
function captureWarnings(callback) {
  return captureConsole("warn", callback);
}
async function captureWarningsAsync(callback) {
  return captureConsoleAsync("warn", callback);
}
export {
  captureConsole,
  captureConsoleAsync,
  captureWarnings,
  captureWarningsAsync
};
//# sourceMappingURL=console.js.map
